<template>

    <b-row>
        <b-col>
            <div class="data-container customer-wrapper">
                <b-table :items="list"
                    :fields="fields"
                    :current-page="page"
                    show-empty
                    :empty-text="(loading) ? 'Loading data' : 'No Data Available'"
                    responsive
                >
                    <template slot="date" slot-scope="data">
                        <!-- {{ data.item }} -->
                        {{ transformDateDisplay({
                            start_date: data.item.start_date,
                            end_date: data.item.end_date
                        }) }}
                    </template>
                    <!-- <template slot="respondents" slot-scope="data">
                        <span class="active">{{ data.item.respondents.active }}</span>
                        <span class="text-muted"> / {{ data.item.respondents.all }}</span>
                    </template> -->
                    <template slot="target_segment_uuid" slot-scope="data">
                        {{ formattedSegmentType(data.item.target_segment_uuid) }}
                    </template>
                    <template slot="action" slot-scope="data">
                        <b-button
                            variant="ghost btn-table-download mr-2"
                            @click="downloadSurvey({
                                survey_id: data.item.id,
                                target_segment_uuid: data.item.target_segment_uuid
                            })">
                        </b-button>
                        <b-button
                            variant="ghost btn-table-view mr-2"
                            @click="actionModal('view', {
                                survey_id: data.item.id,
                                target_segment_uuid: data.item.target_segment_uuid,
                                title: data.item.title,
                                page: 1
                            })">
                        </b-button>
                        <b-button
                            variant="ghost btn-table-edit mr-2"
                            @click="actionModal('edit', {
                                uuid: data.item.uuid
                            })">
                        </b-button>
                        <b-button
                            variant="ghost btn-table-delete"
                            @click="actionModal('delete', {
                                id: data.item.id,
                                title: data.item.title
                            })">
                        </b-button>
                    </template>
                </b-table>
            </div>
        </b-col>
    </b-row>
    
</template>

<script>
import { mapState } from "vuex";

export default {
    name: "SurveyTable",
    data() {
        return {
            fields: [
                {
                    key: "title",
                    sortable: true,
                    thClass: "text-left",
                    tdClass: "text-left"
                },
                {
                    key: "date",
                    label: "Date &amp; Time",
                    sortable: true
                },
                {
                    key: "target_segment_uuid",
                    label: "Segment Type",
                    sortable: true
                },
                {
                    key: "respondents",
                    sortable: true
                },
                {
                    key: "action",
                    thClass: "text-left"
                }
            ],
            page: 1
        };
    },
    computed: {
        ...mapState("engagementSurvey", ["param", "loading", "list", "targetSegments"])
    },
    created: function() {
        this.getList();
    },
    methods: {
        getList: async function() {
            await this.$store.dispatch("engagementSurvey/getList", this.param)
        },

        actionModal: function(type, param) {
            switch(type) {
                case "edit":
                    this.$store.commit("engagementSurvey/setModal", {
                        type: "edit",
                        status: true,
                        uuid: param.uuid
                    });
                    break;
                case "delete":
                    this.$store.commit("engagementSurvey/setModal", {
                        type: "delete",
                        status: true,
                        id: param.id,
                        title: param.title
                    });
                    break;
                case "view":
                    this.$store.commit("engagementSurvey/setModal", {
                        type: "view",
                        status: true,
                        survey_id: param.survey_id,
                        target_segment_uuid: param.target_segment_uuid,
                        title: param.title,
                        page: param.page
                    });
                    break;
            }
        },

        downloadSurvey: async function(param) {
            await this.$store.dispatch("engagementSurvey/export", param);
        },

        transformDateDisplay: function(dates) {
            return this.$moment(dates.start_date).format("MMM DD, YYYY HH:mm") +
                " to " +
                this.$moment(dates.end_date).format("MMM DD, YYYY HH:mm");
        },

        formattedSegmentType: function(uuid) {
            if (uuid === "default") {
                return "All Customers";
            } else {
                if (this.targetSegments !== null && this.targetSegments.length > 0) {
                    for (var i=0; this.targetSegments.length>i; i++) {
                        if (this.targetSegments[i].value === uuid) {
                            return this.targetSegments[i].text;
                        }
                    }
                }
            }

        }
    }
}
</script>
